import { Controller } from "@hotwired/stimulus"

// Hebt ausgewählte Datei und AI-Parser-Karten visuell hervor
export default class extends Controller {
  static targets = ["fileWrapper", "fileLabel", "parserCard"]

  connect() {
    this.setupFileInput()
    this.setupParserRadios()
  }

  setupFileInput() {
    const input = this.element.querySelector('input[type="file"]')
    if (!input) return

    input.addEventListener("change", (e) => {
      if (this.hasFileWrapperTarget) {
        this.fileWrapperTarget.classList.toggle("ring-2", e.target.files.length > 0)
        this.fileWrapperTarget.classList.toggle("ring-indigo-500", e.target.files.length > 0)
        this.fileWrapperTarget.classList.toggle("border-indigo-500", e.target.files.length > 0)
        this.fileWrapperTarget.classList.toggle("border-gray-300", e.target.files.length === 0)
        this.fileWrapperTarget.classList.toggle("bg-indigo-50", e.target.files.length > 0)
      }
      if (this.hasFileLabelTarget && e.target.files.length > 0) {
        this.fileLabelTarget.textContent = e.target.files[0].name
        this.fileLabelTarget.classList.remove("text-gray-500")
        this.fileLabelTarget.classList.add("text-indigo-700", "font-medium")
      } else if (this.hasFileLabelTarget) {
        this.fileLabelTarget.textContent = "PDF, DOC, DOCX (max. 10 MB)"
        this.fileLabelTarget.classList.add("text-gray-500")
        this.fileLabelTarget.classList.remove("text-indigo-700", "font-medium")
      }
    })
  }

  setupParserRadios() {
    const checkboxes = this.element.querySelectorAll('input[name="parser[]"]')
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => this.updateParserHighlight())
    })
    this.updateParserHighlight()
  }

  updateParserHighlight() {
    if (!this.hasParserCardTarget) return

    this.parserCardTargets.forEach((card) => {
      const checkbox = card.querySelector('input[type="checkbox"]')
      const label = card.querySelector('label')
      const isSelected = checkbox && checkbox.checked
      const target = label || card
      target.classList.toggle("border-indigo-500", isSelected)
      target.classList.toggle("bg-indigo-50", isSelected)
    })
  }
}
